import { ORDERS as types } from '@store/constants';


const initialState = {
  orderDetails: {
    isLoading: false,
    isError: false,
    error: null,
    data: null
  }
};

const ordersReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.GETTING_ORDER_BY_ID:
      return {
        ...state,
        orderDetails: {
          ...state.orderDetails,
          isLoading: true,
          isError: false,
          error: null,
          data: null
        }
      };

    case types.GET_ORDER_BY_ID_SUCCESS:
      return {
        ...state,
        orderDetails: {
          ...state.orderDetails,
          isLoading: false,
          isError: false,
          error: null,
          data: payload
        }
      };

    case types.GET_ORDER_BY_ID_FAILURE:
      return {
        ...state,
        orderDetails: {
          ...state.orderDetails,
          isLoading: false,
          isError: true,
          error: payload,
          data: null
        }
      };

    case types.CLEAR_ORDER_DETAILS:
      return {
        ...state,
        orderDetails: {
          ...state.orderDetails,
          isLoading: false,
          isError: false,
          error: null,
          data: null
        }
      };

    // BBPS Complaints moved to bbpsReducer

    default:
      return state;
  }
};

export default ordersReducer;
